import globalCacheManager from './globalCacheManager';

const CACHE_KEY = 'manager';

class ManagerCache {
  constructor() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
    this.isBulkUpdated = false; // Bundle로 업데이트되었는지 여부
  }

  /**
   * 담당자 목록 가져오기
   * @param {boolean} forceRefresh - 강제 새로고침 여부
   * @returns {Promise<Array>} 담당자 목록
   */
  async fetchData(forceRefresh = false) {
    // 페이지 새로고침 중이면 Bundle 분배 대기 — 개별 호출 차단
    if (globalCacheManager.isRefreshing) {
      return this.data || [];
    }

    if (!forceRefresh && this.data) return this.data;

    if (this.pendingPromise && !forceRefresh) return this.pendingPromise;

    this.pendingPromise = (async () => {
      try {
        await globalCacheManager.refreshFromBundle(forceRefresh);
        return this.data || [];
      } catch (error) {
        console.error('[ManagerCache] Error refreshing from bundle:', error);
        return this.data || [];
      } finally {
        this.pendingPromise = null;
      }
    })();

    return this.pendingPromise;
  }

  /**
   * 캐시된 담당자 목록 가져오기 (동기)
   * @returns {Array|null} 담당자 목록 또는 null
   */
  getData() {
    return this.data;
  }

  /**
   * 데이터 직접 설정 (Bundle 분배)
   * @param {Array} data - 담당자 목록
   */
  setData(data) {
    this.data = data || [];
    this.lastFetchTime = Date.now();
    this.isBulkUpdated = true; // Bundle로 업데이트됨
  }

  /**
   * 캐시 무효화
   */
  invalidate() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
    this.isBulkUpdated = false;
  }

  /**
   * 마지막 갱신 시간 가져오기
   * @returns {number|null} 마지막 갱신 시간 (타임스탬프)
   */
  getLastFetchTime() {
    return this.lastFetchTime;
  }
}

// 싱글톤 인스턴스
const managerCache = new ManagerCache();

// 전역 캐시 매니저에 등록
globalCacheManager.register(CACHE_KEY, managerCache);

/**
 * 담당자 목록 가져오기 (캐시 사용)
 * @param {boolean} forceRefresh - 강제 새로고침 여부
 * @returns {Promise<Array>} 담당자 목록
 */
export const fetchManagerListCached = async (forceRefresh = false) => {
  return await managerCache.fetchData(forceRefresh);
};

/**
 * 캐시된 담당자 목록 가져오기 (동기)
 * @returns {Array|null} 담당자 목록 또는 null
 */
export const getManagerListCached = () => {
  return managerCache.getData();
};

/**
 * 담당자 캐시 무효화
 */
export const invalidateManagerCache = () => {
  managerCache.invalidate();
};

export default managerCache;

